export default "__VITE_ASSET__Bt_N2a$k__"